/*
export const someMutation = (state) => {}
 */
import { initialState } from './state'
import Vue from 'vue'
import sharedState from '../shared/state'
import { stat } from 'fs';
export default {
    isLoading,
    doneLoading,
    isLoadingCertificates,
    doneLoadingCertificates,
    setClasses,
    setCurrentSessionIndex,
    setCurrentStudentIndex,
    setSchedulerAffiliates,
    updateAffiliates,
    updateAffiliateFilter,
    updateSessionInstructors,
    updateAddEditClassOpenState,
    updateSelectedTab,
    updateSelectedClasses,
    updateAddNewSession,
    updateAddNewInstructor,
    updateAutocompleteInstructor,
    updateStudentField,
    updateModalMode,
    updateModalLoading,
    updateSessionInformation,
    updateSelectedSession,
    addStudent,
    removeSelectedStudents,
    copyStudentsFromSession,
    updateEditState,
    setAvailableInstructors,
    selectAffiliateForCurrentClass,
    clearInstructors,
    clearCourse,
    setAvailableCourses,
    resetState,
    updateAffiliateToggleState,
    autocompleteAddressSessionUpdate,
    autocompleteAddressSessionStudentUpdate,
    storeClassId,
    setSessionStudentInformation,
    setSessionRereportStudentInformation,
    setScheduleUploadOpen,
    resetScheduleUpload,
    resetSearchFields,
    setProcessedRows,
    updateSelectedProcessedRows,
    removeSelectedProcessedRows,
    setInstructorSearch,
    setAffiliateSearch,
    setClassAffiliateSearch,
    setProcessing,
    updateSelectedClassType,
    setMeetingLinkModal,
    updateSelectedStudentCounts,
    setIncludeExpiredClasses,
    setIncludeInactiveAffiliates,
    updateInitialSessionForComparison
}

function updateInitialSessionForComparison (state, v) {
    state.initialSessionForComparison = v
}

function setIncludeExpiredClasses (state, v) {
    state.includeExpiredClasses = v
}

function setIncludeInactiveAffiliates (state, v) {
    console.log(v)
    state.searchFields['INCLUDE_INACTIVE_AFF'] = v
}

function updateSelectedStudentCounts (state, { selected }) {
    let sessions = state.sessionInformation.sessions
    sessions.map((sess,sessionIndex) => {
        let students = sess.students
        students.map((stu,stuIndex) => {
            if (selected.filter(s => s.studentId == stu.studentId).length) {
                state.sessionInformation.sessions[sessionIndex].students[stuIndex].emailsSent++
            }
        })
    })
}

function setMeetingLinkModal (state, payload) {
    state.meetingLinkModal = payload
}

function updateSelectedClassType (state,payload) {
    state.sessionInformation.selectedClassType = payload
}

function setProcessing (state, payload) {
    state.processingClass = payload
}

function isLoading (state) {
    state.loadingData = true
}

function doneLoading (state) {
    state.loadingData = false
}

function setInstructorSearch (state, payload) {
    state.searchFields['~INSTRUCTOR_ID'] = payload ? payload.item.INSTRUCTOR_ID : null
}

function setAffiliateSearch (state, payload) {
    state.searchFields['AFFILIATE_ID'] = payload ? payload.item.AFFILIATE_ID : null
}

function setClassAffiliateSearch(state, payload) {
    state.sessionInformation.selectedAffiliate = payload ? payload.item.AFFILIATE_ID : null
}

function isLoadingCertificates (state) {
    state.loadingCertificates = true
}
  
function doneLoadingCertificates (state) {
    state.loadingCertificates = false
}

function setClasses (state, classes) {
    classes.map(c => c.expand = false)
    state.classList = classes
}

function setCurrentSessionIndex (state, index) {
    state.currentSessionIndex = index
}

function setCurrentStudentIndex (state, index) {
    state.currentStudentIndex = index
}

function setScheduleUploadOpen (state, open) {
    state.scheduleUploadOpen = open
    if(open){
        state.processedRows = []
        state.scheduleProcessed = false
        state.selectedScheduleProcessRows = []
        state.processingSchedule = false
    }
}
function resetSearchFields(state){
    state.searchFields = _.cloneDeep(initialState.searchFields)
}

function resetScheduleUpload(state){
    state.processedRows = []
    state.scheduleProcessed = false
    state.selectedScheduleProcessRows = []
    state.processingSchedule = false
}

function setProcessedRows (state, payload){
    state.processedRows = payload
}

function setSchedulerAffiliates (state, {result, alreadySelected}) {
    let affiliates = []
    _.map(result.data.payload, (i,index) => {
        let oldAffiliate = _.find(alreadySelected,{AFFILIATE_ID:i.AFFILIATE_ID})
        let affiliate = _.find(affiliates,{AFFILIATE_ID:i.AFFILIATE_ID})
        if (!affiliate) {
            let selected = false
            let open = false
            if( oldAffiliate && oldAffiliate.selected) selected = true
            if( oldAffiliate && oldAffiliate.open) open = true
            determineIfSelected(oldAffiliate,i)
            affiliates.push({
                AFFILIATE_ID: i.AFFILIATE_ID,
                AFFILIATE_CODE: i.AFFILIATE_CODE,
                AFFILIATE_NAME: i.AFFILIATE_NAME,
                selected: selected,
                open: open,
                INSTRUCTORS: [cleanInstructor(i)]
            })
        } else {
            determineIfSelected(oldAffiliate,i)
            if(affiliate){
                affiliate.INSTRUCTORS.push(cleanInstructor(i))
            }
        }
    })

    // Alphabetical Sort
    affiliates.sort(function(a, b){
        if(a.AFFILIATE_NAME < b.AFFILIATE_NAME) { return -1; }
        if(a.AFFILIATE_NAME > b.AFFILIATE_NAME) { return 1; }
        return 0;
    })

    // If theres only one, lets go on ahead and select it.
    if(affiliates.length == 1 && alreadySelected.length == 0){
        affiliates[0].open = true
        affiliates[0].selected = true
        affiliates[0].INSTRUCTORS.map(x => {x.selected = true})
    }

    state.affiliates = affiliates
    state.filteredAffiliates = affiliates
    return affiliates
}
function determineIfSelected(oldAffiliate,i){
    if(oldAffiliate && oldAffiliate.INSTRUCTORS){
        let oldInstructor = _.find(oldAffiliate.INSTRUCTORS, {INSTRUCTOR_ID: i.INSTRUCTOR_ID})
        if(oldInstructor && oldInstructor.selected) i.selected = true
    }
}
function updateAffiliates (state, payload) {
    _.map(payload.getAffiliates, affiliate => {
        let uncheckAllInstructors = false,
            checkAllInstructors
        if (payload.affiliate === affiliate.AFFILIATE_ID){
            if(payload.selected === false) uncheckAllInstructors = true
            if(payload.selected === true ) checkAllInstructors = true
        }
        
        _.map(affiliate.INSTRUCTORS, instructor => {
            if (payload.instructor === instructor.INSTRUCTOR_ID && payload.selected === false) {
                affiliate.selected = false
            }
            if (affiliate.selected || checkAllInstructors) {
                instructor.selected = true    
            }
            if (uncheckAllInstructors) {
                instructor.selected = false
            }
        })
    })
    state.filteredAffiliates = payload.getAffiliates
}

function updateAffiliateFilter (state, payload) {
    let filter = state.affiliateFilter = payload
        filter = filter.toLowerCase().trim()
    
    state.filteredAffiliates = state.affiliates
    
    // Return all if no search
    if(!filter){
        _.map(state.affiliates, a => {a.open = false})
        return
    } 
    
    const regex = new RegExp(filter)
    
    // Match the affiliates name
    let results = _.filter(state.affiliates, (affiliate) =>{
        if(!affiliate) return false
        if(!affiliate.AFFILIATE_NAME) return false
        
        let affiliateMatch = regex.test(affiliate.AFFILIATE_NAME.toLowerCase())
        
        // Match the instructors name
        let instructorMatches = _.filter(affiliate.INSTRUCTORS, instructor => {
            let firstNameMatch = regex.test(instructor.USER_FIRST_NAME.toLowerCase())
            let lastNameMatch = regex.test(instructor.USER_LAST_NAME.toLowerCase())
            let firstLastMatch = regex.test(instructor.USER_FIRST_NAME.toLowerCase() + " " + instructor.USER_LAST_NAME.toLowerCase())
            let isMatch = (firstNameMatch || lastNameMatch || firstLastMatch)
            return isMatch
        })
        let filteredAffiliate = _.find(state.filteredAffiliates, {AFFILIATE_ID: affiliate.AFFILIATE_ID})
        if(filteredAffiliate){
            filteredAffiliate.open = (instructorMatches.length > 0)
        }

        return (affiliateMatch || instructorMatches.length > 0)
    })
    state.filteredAffiliates = results
}

function updateSessionInstructors(state, { index, item }) {
    
}

function updateAffiliateToggleState(state, {affiliateIndex, isMatch}){
    let currentOpenState =state.affiliates[affiliateIndex].open
    if(currentOpenState != isMatch){
        state.affiliates[affiliateIndex].open = isMatch
    }
}
function cleanInstructor (i) {
    delete i.AFFILIATE_ID
    delete i.AFFILIATE_CODE
    delete i.AFFILIATE_NAME
    i.selected = i.selected || false
    return i  
}

function updateAddEditClassOpenState (state, payload) {
    state.classesModalState = payload
    state.autoCompleteStudentDate=false;
}

function updateSelectedTab (state, payload) {
    state.selectedTab = payload
}

function updateSelectedClasses (state, selectedClasses) {
    state.selectedClasses = [...selectedClasses]
  }

function updateAddNewSession (state) {
    let sessions = state.sessionInformation.sessions
    let newSessionText = `Session ${sessions.length + 1}`
    let newSession = _.cloneDeep(state.initialSessionState)
    newSession.label = newSessionText
    newSession.value = newSessionText
    sessions.push(newSession)
    state.sessionInformation.selected = newSessionText
    state.selectedTab = 'details'
}

function updateAutocompleteInstructor (state, payload) {
    state.sessionInformation.sessions[payload.sessionIndex].instructors[payload.instructorIndex] = payload.selected
}

function updateAddNewInstructor (state, payload) {
    let currentInstructors = state.sessionInformation.sessions[payload.sessionIndex].instructors
    if (payload.delete === true) {
        currentInstructors.splice(payload.instructorIndex, 1)
    } else {
        currentInstructors.push({label: "", value: ""})
    }
    state.sessionInformation.sessions[payload.sessionIndex].instructors = currentInstructors
}

function updateStudentField (state, payload) {
    state.sessionInformation.sessions[payload.session].students[payload.index][payload.field] = payload.new
}

function updateModalMode (state, payload) {
    if (payload) state.sessionInformation.mode = payload
    if (payload === 'add') {
        state.canEdit = true
    }
}

function updateModalLoading (state, payload) {
    if (payload !== null) state.sessionInformation.loading = payload
}

function updateSessionInformation (state, payload) {
    state.selectedTab = 'details'
    if (payload.newClass) {
        state.sessionInformation = _.cloneDeep(state.initialState)
        state.sessionInformation.sessions[0].startDate = payload.start
        state.sessionInformation.sessions[0].endDate = payload.end
        state.sessionInformation.sessions[0].minStart = payload.minStart
    } else {        
        state.sessionInformation = _.cloneDeep(payload)
    }
}

function updateSelectedSession (state, payload) {
    let indexToSelect = _.findIndex(state.sessionInformation.sessions, (s) => {
        return s.sessionId === payload
    })
    if (indexToSelect >= 0) {
        state.sessionInformation.selected = `Session ${indexToSelect + 1}`
    }
}

function updateSelectedProcessedRows (state, selected, index) {
    state.selectedScheduleProcessRows = [...selected]
}

function removeSelectedProcessedRows (state) {
    const selectedIndexes = state.selectedScheduleProcessRows.map(item => item.__index)
    selectedIndexes.forEach((item) => {
        delete state.processedRows[item]
    })
    Vue.set(state, 'processedRows', state.processedRows.filter(item => item))
    state.selectedScheduleProcessRows = []
}

function addStudent (state, payload) {
    state.sessionInformation.sessions[payload].students.push(_.cloneDeep(state.initialStudentRow))
}

function removeSelectedStudents (state, payload) {
    const { students, studentsToDelete } = state.sessionInformation.sessions[payload.session]
    const studentIds = students
        .filter((_, idx) => payload.students.includes(idx))
        .map(s => s.studentId)

      state.sessionInformation.sessions[payload.session].studentsToDelete =
        studentsToDelete ?
          state.sessionInformation.sessions[payload.session].studentsToDelete.concat(studentIds)
          : studentIds

    const originalStudents = state.sessionInformation.sessions[payload.session].students
    state.sessionInformation.sessions[payload.session].students = _.filter(originalStudents, (student, i) => {
        return payload.students.indexOf(i) === -1
    })
}

function copyStudentsFromSession (state, payload) {
    state.sessionInformation.sessions[payload.current].students = _.cloneDeep(state.sessionInformation.sessions[payload.target].students)
}

function updateEditState (state, payload) {
    state.canEdit = payload
}

function selectAffiliateForCurrentClass (state, payload){
    state.sessionInformation.selectedAffiliate = payload
}

function clearInstructors(state,index){
    state.sessionInformation.sessions[index].instructors = []
}

function clearCourse(state){
    state.sessionInformation.selectedCourse = null
}

function setAvailableCourses(state, payload){
    state.sessionInformation.courses = payload
}

function setAvailableInstructors(state, payload){
    state.sessionInformation.availableInstructors = payload
    console.log(state.sessionInformation.availableInstructors,payload)
}

function resetState (state) {
    // _.each(state, (value, key) => {
    //     state[key] = initialState[key]
    // })
    state = { ...initialState }
}

function setSessionStudentInformation(state, {studentIndex,type,value,sessionIndex,justSync}) {
    let currentStudent = state.sessionInformation.sessions[sessionIndex].students[studentIndex]
    // Sync updates if student DL is same.
    state.sessionInformation.sessions.map((session, s_index) => {
        session.students.map((student) => {
            if (student.dl === currentStudent.dl && student.dl && student.dl.trim() != "" && sessionIndex != s_index) {
                student[type] = value                
                student.syncing = true
                if (student.studentId) currentStudent.studentId = student.studentId 
                
            }
            else {
                student.syncing = false
            }
        })
    })
    if (!justSync) {
        Vue.set(state.sessionInformation.sessions[sessionIndex].students[studentIndex],type,value)
        
        if(type == 'dlState') {
            let foundState = _.find(sharedState.states,{LK_STATE_ID: value})
            if(foundState) state.sessionInformation.sessions[sessionIndex].students[studentIndex]['dlStateName'] = _.cloneDeep(foundState.STATE)
        }
    }
    let initialStudentForComparison = state.initialSessionForComparison.sessions[sessionIndex].students[studentIndex]
    if (initialStudentForComparison) {
        let dirty = (initialStudentForComparison[type] != value)
        Vue.set(state.sessionInformation.sessions[sessionIndex].students[studentIndex],'dirty',dirty)
    }
}

function setSessionRereportStudentInformation(state, { id, studentIndex, field, value, reset, remove }) {
    if(reset) {
        state.sessionInformation.rereportStudents[studentIndex] = { studentId: id }
    }
    if(field) {
        state.sessionInformation.rereportStudents[studentIndex][field] = value
    }
    if(remove) {
        delete state.sessionInformation.rereportStudents[studentIndex]
    }
}

function autocompleteAddressSessionUpdate(state, { sessionId, place, stateOptions }){
    // Assign Address values
    let a = place.address_components
    console.log(a)
    state.sessionInformation.sessions[sessionId].address1 = `${addrPart('street_number',a).long_name || ''} ${addrPart('route',a).long_name || ''}`
    state.sessionInformation.sessions[sessionId].address2 = ''
    state.sessionInformation.sessions[sessionId].city = `${addrPart('locality',a).long_name || addrPart('sublocality',a).long_name || ''}`
    state.sessionInformation.sessions[sessionId].county = `${addrPart('administrative_area_level_2',a).long_name.replace(" County","") || ''}`
    state.sessionInformation.sessions[sessionId].zip = `${addrPart('postal_code',a).short_name || ''}`
    
    let foundState = _.find(stateOptions,{label: addrPart('administrative_area_level_1',a).short_name.toUpperCase()})
    if(foundState && foundState.value){
        state.sessionInformation.sessions[sessionId].state = foundState.value
    }
}

function autocompleteAddressSessionStudentUpdate(state, { sessionId, studentIndex, place, stateOptions }){
    // Assign Address values
    let a = place.address_components
    state.sessionInformation.sessions[sessionId].students[studentIndex].address1 = `${addrPart('street_number',a).long_name || ''} ${addrPart('route',a).long_name || ''}`
    state.sessionInformation.sessions[sessionId].students[studentIndex].city = `${addrPart('locality',a).long_name || addrPart('sublocality',a).long_name || ''}`
    state.sessionInformation.sessions[sessionId].students[studentIndex].zip = `${addrPart('postal_code',a).short_name || ''}`
    
    let foundState = _.find(stateOptions,{label: addrPart('administrative_area_level_1',a).short_name.toUpperCase()})
    if(foundState && foundState.value){
        console.log(foundState)
        state.sessionInformation.sessions[sessionId].students[studentIndex].stateId = foundState.value
        state.sessionInformation.sessions[sessionId].students[studentIndex].stateName = foundState.label
    }
}

// Part part of an address based on the type
function addrPart(type,address){
    return _.find(address,{types:[type]}) || {long_name:null,short_name:null}
}
function storeClassId(state,payload){
    state.classId = payload ;
}
